import { DeleteProcessChainResponseSchema } from './delete-process-chain.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const deleteProcessChainContract = {
    method: 'DELETE',
    path: '/api/v2/process-chains/:id',
    description: 'Delete a process chain (fails if chain has children)',
    responseSchema: DeleteProcessChainResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Chain has children - delete or reassign children first',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Chain not found'
        }
    }
};

//# sourceMappingURL=delete-process-chain.contract.js.map